var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center justify-center py-3 px-4"},[_c('p',{staticClass:"text-xl text-gray-700 italic h-16",domProps:{"innerHTML":_vm._s(_vm.calculated_status_text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }